import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Package, Price } from '../models';

export default function usePastImagesQuickOrderPricelist(schoolId) {
  return useQuery({
    queryKey: [QueryKeys.pastImagesQuickOrder, QueryKeys.pricelist, schoolId],
    queryFn: () => (
      Package
        .selectExtra(['defaultBackgroundUrl'])
        .includes({
          backgroundSet: 'backgrounds',
          options: ['image_types', 'prices'],
          package_poses: 'background',
        })
        .merge({ prices: Price.where({ for_school: schoolId }) })
        .where({ pastImagesQuickOrder: true })
        .where({ schoolId })
        .all()
        .then((res) => (res.data && res.data[0]) || null)
    ),
    placeholderData: null,
    staleTime: 60_000,
    enabled: !!schoolId,
  });
}
